import { forwardRef, Input, InputProps } from '@chakra-ui/react';
import { useCallback } from 'react';

export type TextInputProps = Omit<InputProps, 'value' | 'onChange'> & {
    value: string;
    onChange: (value: string, target: HTMLInputElement) => void;
};

const TextInput = forwardRef<TextInputProps, 'input'>(
    ({ value, onChange, ...props }, ref) => {
        const handler = useCallback(
            (e: { target: HTMLInputElement }) => {
                const value = e.target.value || '';
                onChange(value, e.target);
            },
            [onChange]
        );
        return <Input {...props} value={value} onChange={handler} ref={ref} />;
    }
);

export default TextInput;
